import { CITATIONS } from 'common/endpoints';
import BaseServiceRetryWrapper from './baseRetry';

class CitationService extends BaseServiceRetryWrapper {
  deleteCitation = (citationId: number) => this.delete(CITATIONS.deleteCitation(citationId));

  updateCitationAcceptance = (citationId: number, isAccepted: boolean) =>
    this.patch(CITATIONS.updateCitationAcceptance(citationId), { is_accepted: isAccepted });

  acceptAllCitations = (documentReferenceId: number) =>
    this.patch(CITATIONS.acceptAllCitations(), { document_reference_id: documentReferenceId });
}

export default CitationService;

